// 图片面板功能菜单

export enum ImagePanelFeatureType {
    /** 基础调色 */
    ADJUST_BASE = 'adjust_base',
    /** 消除笔 */
    ADJUST_ELIMINATE = 'adjust_eliminate_pen',
    /** AI 消除笔 */
    ADJUST_AI_ELIMINATE = 'adjust_ai_eliminate_pen',
    /** 光效 */
    ADJUST_LIGHT = 'adjust_light',
    /** 色彩 */
    ADJUST_COLOR = 'adjust_color',
    /** 色调分离 */
    ADJUST_POSTERIZE = 'adjust_posterize',
    /** hsl */
    ADJUST_HSL = 'adjust_hsl',
    /** 细节 */
    ADJUST_PARTICULARS = 'adjust_particulars',
}

// 标注笔限免标记
// 改成false变成收费功能
export const markupFree = true;
